import React, { useState } from 'react'
import { isNil } from 'ramda'
import PropTypes from 'prop-types'
import { useFormik } from 'formik'
import { useIntl } from 'react-intl'
import CancelOutlinedIcon from '@material-ui/icons/CancelOutlined'
import {
  Radio,
  IconButton,
  Typography,
  RadioGroup,
  makeStyles,
  FormControl,
  FormControlLabel,
} from '@material-ui/core'

import { CANCEL } from 'app/constants/button'
import SimpleInput from 'app/componentV4/Input/SimpleInput'
import PrimaryTooltip from 'app/componentV4/Tooltip/PrimaryTooltip'
import SubmitDialog from 'app/componentV4/Dialog/SubmitDialog'

import {
  UNSENT_EVENT,
  CANCEL_EVENT,
  MAX_LENGTH_CENCEL_REASON,
} from 'app/constants/messageDetail'

const useStyles = makeStyles({
  root: {
    '& .MuiTypography-body1': {
      fontWeight: 'bold',
    },
  },
})

const CancelUnsentEvent = (props) => {
  const { onSubmit, onDialog } = props
  const classes = useStyles()
  const { formatMessage } = useIntl()

  const [isOpen, setIsOpen] = useState(false)

  const formik = useFormik({
    initialValues: {
      type: CANCEL_EVENT,
      reason: null,
    },
  })

  const handleOpen = () => {
    setIsOpen(true)
    onDialog(true)
  }

  const handleClose = () => {
    setIsOpen(false)
    onDialog(false)
    // formik.resetForm()
  }

  const handleSubmitText = () => {
    if (formik.values.type === UNSENT_EVENT)
      return formatMessage({
        id: 'timeline.dialog.title.unsend.event',
      })
    else if (formik.values.type === CANCEL_EVENT)
      return formatMessage({
        id: 'timeline.dialog.title.cancel.event',
      })
  }

  return (
    <>
      <PrimaryTooltip
        title={formatMessage({
          id: 'timeline.dialog.title.cancel.event',
        })}
      >
        <IconButton
          aria-label="Delete Button Icon"
          size="small"
          className="text-red-500"
          onClick={() => {
            handleOpen()
          }}
        >
          <CancelOutlinedIcon fontSize="small" />
        </IconButton>
      </PrimaryTooltip>
      <SubmitDialog
        id="dialog-cancel-unsend-event"
        open={isOpen}
        title={formatMessage({
          id: 'timeline.dialog.title.cancel.unsend.event',
        })}
        submitText={handleSubmitText()}
        onSubmit={async () => {
          await onSubmit(formik.values.type, formik.values.reason)
          handleClose()
        }}
        closeText={formatMessage({
          id: 'text.close',
        })}
        onClose={() => handleClose()}
        className={classes.root}
        type={CANCEL}
      >
        <div className="flex justify-center mb-10">
          <FormControl variant="outlined" className="w-full px-5">
            <RadioGroup
              defaultValue={formik.values.type}
              aria-label="unsend-cancel"
              name="unsend-cancel"
              onChange={(event) =>
                formik.setFieldValue('type', event.target.value)
              }
            >
              <FormControlLabel
                name="cancel"
                labelPlacement="start"
                value={CANCEL_EVENT}
                control={<Radio color="primary" />}
                label={formatMessage({
                  id: 'timeline.dialog.title.cancel.event',
                })}
                className="w-full justify-between m-0 capitalize text-14 text-primary"
              />
              <Typography className="mb-10 font-400">
                {formatMessage({
                  id: 'timeline.dialog.description.cancel.event',
                })}
              </Typography>
              <FormControlLabel
                name="unsend"
                labelPlacement="start"
                value={UNSENT_EVENT}
                control={<Radio color="primary" />}
                label={formatMessage({
                  id: 'timeline.dialog.title.unsend.event',
                })}
                className="w-full justify-between m-0 capitalize text-14 text-primary"
              />
              <Typography className="mb-10 font-400">
                {formatMessage({
                  id: 'timeline.dialog.description.unsent.event',
                })}
              </Typography>
            </RadioGroup>
            {formik.values.type === CANCEL_EVENT ? (
              <>
                <SimpleInput
                  id="reason-cancel-event"
                  name="reason"
                  placeholder={formatMessage({
                    id: 'text.type.your.message',
                  })}
                  value={formik.values.reason}
                  size="small"
                  multiline
                  fullWidth
                  rows={4}
                  inputProps={{
                    maxLength: MAX_LENGTH_CENCEL_REASON,
                  }}
                  onChange={(event) => {
                    formik.setFieldValue('reason', event.target.value)
                  }}
                />
                <Typography className="text-grey-300 text-12 flex item-center absolute bottom-0 right-0 my-2 mx-10">
                  {`${isNil(formik.values.reason) ? 0 : formik.values.reason.length}/${MAX_LENGTH_CENCEL_REASON}`}
                </Typography>
              </>
            ) : null}
          </FormControl>
        </div>
      </SubmitDialog>
    </>
  )
}

CancelUnsentEvent.propTypes = {
  className: PropTypes.string,
  onSubmit: PropTypes.func,
  onDialog: PropTypes.func,
}

export default CancelUnsentEvent
